import axios from 'axios';

// Use relative URL in Docker (nginx proxies /api to backend)
// Or use env var for local development
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Services
export const getServices = async () => {
  const response = await apiClient.get('/services');
  return response.data;
};

export const getServiceHealth = async (serviceName) => {
  const response = await apiClient.get(`/services/${serviceName}/health`);
  return response.data;
};

// Metrics
export const getMetrics = async (serviceName, metricName, limit = 100) => {
  const response = await apiClient.get(`/metrics/${serviceName}/${metricName}`, {
    params: { limit },
  });
  return response.data;
};

export const generateRealtimeMetric = async (serviceName, metricName) => {
  const response = await apiClient.post(`/metrics/realtime`, null, {
    params: { service_name: serviceName, metric_name: metricName },
  });
  return response.data;
};

// Anomalies
export const getAnomalies = async (status = null, serviceName = null, limit = 100) => {
  const params = {};
  if (status) params.status = status;
  if (serviceName) params.service_name = serviceName;
  params.limit = limit;
  
  const response = await apiClient.get('/anomalies', { params });
  return response.data;
};

export const getAnomaly = async (anomalyId) => {
  const response = await apiClient.get(`/anomalies/${anomalyId}`);
  return response.data;
};

export const updateAnomalyStatus = async (anomalyId, status) => {
  const response = await apiClient.put(`/anomalies/${anomalyId}/status`, null, {
    params: { status },
  });
  return response.data;
};

export const analyzeRootCause = async (anomalyId) => {
  const response = await apiClient.post(`/anomalies/${anomalyId}/analyze`);
  return response.data;
};

// Traces
export const getTraces = async (limit = 50, status = null) => {
  const params = { limit };
  if (status) params.status = status;
  const response = await apiClient.get('/traces', { params });
  return response.data;
};

export const generateTrace = async (injectAnomaly = false) => {
  const response = await apiClient.post('/traces/generate', null, {
    params: { inject_anomaly: injectAnomaly },
  });
  return response.data;
};

export const getTrace = async (traceId) => {
  const response = await apiClient.get(`/traces/${traceId}`);
  return response.data;
};

export const getTraceStats = async (traceId) => {
  const response = await apiClient.get(`/traces/${traceId}/stats`);
  return response.data;
};

export const getTraceCriticalPath = async (traceId) => {
  const response = await apiClient.get(`/traces/${traceId}/critical-path`);
  return response.data;
};

// Dashboard
export const getDashboardStats = async () => {
  const response = await apiClient.get('/dashboard/stats');
  return response.data;
};

export const getRealtimeData = async () => {
  const response = await apiClient.get('/dashboard/realtime');
  return response.data;
};

// Detection
export const detectAnomaly = async (serviceName, metricName, value) => {
  const response = await apiClient.post('/detect', {
    service_name: serviceName,
    metric_name: metricName,
    value,
  });
  return response.data;
};
